export default __webpack_public_path__ + "images/cf08b1cff3fdde914fb1f871175f5592-free-truck.svg";